<template>
	<div class="section"><slot></slot></div>
</template>
<script>
	export default { name: "uSection" }
</script>


// WEBPACK FOOTER //
// src/components/uSection/uSection.vue